import { render } from "./notification-card.vue?vue&type=template&id=0f1c152c&scoped=true"
import script from "./notification-card.vue?vue&type=script&lang=js"
export * from "./notification-card.vue?vue&type=script&lang=js"

import "./notification-card.vue?vue&type=style&index=0&id=0f1c152c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f1c152c"]])

export default __exports__